import type * as React from "react";

import { markShape } from "./Swipe";
import { cn } from "../lib/cn";

/** Deliberately not the status tones: a state with a highlighter is a `Swipe`. */
export type StatusMarkTone = "neutral" | "accent";

const toneInk: Record<StatusMarkTone, string> = {
  neutral: "text-annotation",
  // accent-deep is the small-text indigo.
  accent: "text-accent-deep",
};

export interface StatusMarkProps extends Omit<
  React.HTMLAttributes<HTMLSpanElement>,
  "children"
> {
  tone?: StatusMarkTone;
  icon?: React.ReactNode;
  children: React.ReactNode;
  ref?: React.Ref<HTMLSpanElement>;
}

/**
 * The toneless branch beside a `Swipe` ("Nobody eligible"). A state mapping to
 * a highlighter is a `Swipe`; a fact (species, record type) is a `Tag`.
 */
export function StatusMark({
  tone = "neutral",
  icon,
  children,
  className,
  ...rest
}: StatusMarkProps) {
  return (
    <span
      className={cn(
        markShape.row,
        "text-annotation-caps",
        toneInk[tone],
        className,
      )}
      {...rest}
    >
      {icon != null && (
        <span aria-hidden="true" className={markShape.icon}>
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
